const initialState = {
	isLoading: 0,
	error: {},
	addresses: []
}

export default (state = initialState, action) => {
	switch (action.type){
		case 'SHIPPING_ADDRESSES_LOADING':
			return {
				...state,
                isLoading: 1,
                addresses: [],
                error: {}
			}
		case 'SHIPPING_ADDRESSES_ERROR':
			return {
				...state,
				isLoading: 0,
				error: action.err
			}
        case 'SHIPPING_ADDRESSES_SUCCESS':
			return {
				...state,
				addresses: action.payload.addresses ? action.payload.addresses : [],
				isLoading: 0
			}

		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/store/reducers/shippingAddress.js